import { useContext } from 'react';
import { TreeViewContext } from '../Context';

export const useTreeViewContext = () => {
  const context = useContext(TreeViewContext);
  if (!context) {
    throw new Error('useTreeViewContext must be used within a TreeView');
  }
  return context;
};
